<template>
  <div>
    <ValidationProvider
      v-slot="{ errors }"
      class="lv-upload-file-list"
      :rules="rules"
      :class="{ 'flex-auto': flexAuto }"
    >
      <input type="hidden" :value="attaches" />
      <LvFlexBox>
        <LvText h6 bold> {{ $t(title) }}<LvText v-if="required" h6 red bold>*</LvText> </LvText>
        <IconButton
          v-if="draggable && attaches.length > 1"
          icon="icon-md-import-export"
          tooltipText="排序"
          @click="$_onOpenDragPopup"
        />
      </LvFlexBox>
      <div class="lv-upload-file-list__content" :class="{ 'mobile-row': mobileRow }">
        <LvDownloadFileBtn
          v-for="(attach, attach_k) in attaches"
          :key="attach_k"
          :id="attach.id"
          :num="attach_k"
          :upload="upload"
          :url="attach.url"
          :name="attach.name"
          :download="download"
          :fileType="attach.fileType"
          :hasScope="attach.hasScope"
          :isSystem="attach.isSystem"
          :chipList="attach.chipList"
          :isLoading="attach.isLoading"
          :saveToStorage="saveToStorage"
          :showDeleteBtn="showDeleteBtn"
          :versionNumber="attach.versionNumber"
          :module="uploadModule"
          :showDownloadBtn="attach.showDownloadBtn"
          :isClickable="attach.isClickable"
          :isImageViewable="_isImageViewable && !saveToStorage"
          class="uploaded-file"
          @go-to="$emit('go-to', $event)"
          @remove="$_onRemoveFile(attach_k)"
        >
          <template v-slot:header>
            <slot name="header" :index="attach_k"></slot>
          </template>
        </LvDownloadFileBtn>
        <LvUploadFileBtn
          v-if="_isShowUploadBtn"
          :value="uploadFiles"
          :oneFile="oneFile"
          :btnText="btnText"
          :multiple="multiple"
          :remindText="remindText"
          :uploadModule="uploadModule"
          :saveToStorage="saveToStorage"
          :acceptFileType="acceptFileType"
          :selectedFileList="attaches"
          :hasError="errors.length > 0"
          :versionMode="versionMode"
          :disabled="disableUpload"
          class="upload-button"
          @input="$_onAttachFiles($event)"
        />
        <div v-if="errors.length > 0" class="lv-upload-file-list__warning-text">
          <i class="icon-warning invalid-icon" />
          <LvText v-for="(text_e, text_k) in errors" :key="text_k" red remark class="ml-4">
            {{ $t(text_e) }}
          </LvText>
        </div>
      </div>
    </ValidationProvider>
    <LvPopupDrag
      ref="LvPopupDrag"
      :titleKey="dragTitleKey"
      @submit="$emit('submit-drag', $event)"
    />
  </div>
</template>

<script>
import { extend } from 'vee-validate';
import { ValidationProvider } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: '此項目為必填',
});

export default {
  components: { ValidationProvider },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    upload: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '附件',
    },
    mobileRow: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: '上傳',
    },
    oneFile: {
      type: Boolean,
      default: false,
    },
    remindText: {
      type: String,
    },
    rules: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    flexAuto: {
      type: Boolean,
      default: false,
    },
    download: {
      type: Boolean,
      default: true,
    },
    showDeleteBtn: {
      type: Boolean,
      default: true,
    },
    saveToStorage: {
      type: Boolean,
      default: false,
    },
    uploadModule: {
      type: String,
    },
    acceptFileType: {
      type: String,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    dragTitleKey: {
      type: String,
      default: 'name',
    },
    versionMode: {
      type: String,
      default: '',
    },
    disableUpload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      attaches: [],
      uploadFiles: [],
    };
  },
  computed: {
    _isShowUploadBtn() {
      return !(this.oneFile && this.attaches.length === 1);
    },
    _isImageViewable() {
      return this.$store.state.app.factory.isImageViewable;
    },
  },
  watch: {
    attaches() {
      this.$emit('input', this.attaches);
    },
    value() {
      this.attaches = this.value;
    },
  },
  mounted() {
    this.attaches = this.value;
  },
  methods: {
    $_onRemoveFile(index) {
      this.attaches.splice(index, 1);
    },
    $_onAttachFiles($event) {
      this.attaches = this.attaches.concat($event);
    },
    $_onOpenDragPopup() {
      const LvPopupDrag = this.$refs.LvPopupDrag;
      if (!LvPopupDrag) return;
      LvPopupDrag.open(this.attaches);
    },
  },
};
</script>
